import React from 'react';
import PropTypes from 'prop-types';

const LightTheme = React.lazy(() => import('./LightTheme'));

// Dark mode removido: o toggle era um artefato do template (fazia reload de
// página e não estilizava os componentes PhadaUI, que leem cores estáticas de
// tokens.js). O app é light-only — sempre carrega o LightTheme.
const ThemeSelector = ({ children }) => {
  return (
    <>
      <LightTheme />
      {children}
    </>
  );
};

ThemeSelector.propTypes = {
  children: PropTypes.node,
};

export default ThemeSelector;
